// Studyo Today Backend
// Package studyo.today.curriculum.v1.resources
// Resource definitions
// Copyright (c) 2015-2023 Intuitic Inc.

// @generated by protoc-gen-es v2.2.3 with parameter "import_extension=js"
// @generated from file studyo/today/curriculum/v1/resources/course.proto (package studyo.today.curriculum.v1.resources, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import { file_studyo_today_curriculum_v1_resources_user_persona } from "./user_persona_pb.js";

/**
 * Describes the file studyo/today/curriculum/v1/resources/course.proto.
 */
export const file_studyo_today_curriculum_v1_resources_course = /*@__PURE__*/
  fileDesc("CjFzdHVkeW8vdG9kYXkvY3VycmljdWx1bS92MS9yZXNvdXJjZXMvY291cnNlLnByb3RvEiRzdHVkeW8udG9kYXkuY3VycmljdWx1bS52MS5yZXNvdXJjZXMifQoGQ291cnNlEgoKAmlkGAEgASgJEg0KBXRpdGxlGAIgASgJEhMKC2Rlc2NyaXB0aW9uGAMgASgJEkMKCHBlcnNvbmFzGAQgAygOMjEuc3R1ZHlvLnRvZGF5LmN1cnJpY3VsdW0udjEucmVzb3VyY2VzLlVzZXJQZXJzb25hQiyqAilTdHVkeW8uVG9kYXkuQ3VycmljdWx1bS5HcnBjLlYxLlJlc291cmNlc2IGcHJvdG8z", [file_studyo_today_curriculum_v1_resources_user_persona]);

/**
 * Describes the message studyo.today.curriculum.v1.resources.Course.
 * Use `create(CourseSchema)` to create a new message.
 */
export const CourseSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_curriculum_v1_resources_course, 0);

